module.exports = __webpack_public_path__ + "img/facebook-logo-o.0750370c.svg";